import { render, staticRenderFns } from "./Comp10t3.vue?vue&type=template&id=4013ca71&scoped=true&"
import script from "./Comp10t3.vue?vue&type=script&lang=js&"
export * from "./Comp10t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp10t3.vue?vue&type=style&index=0&id=4013ca71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013ca71",
  null
  
)

export default component.exports